// BOM LINE ITEM STATUS
export const NO_FOUND           = 'NO_FOUND';
export const PERFECT_MATCH      = 'PERFECT_MATCH';
export const MANY_PERFECT_MATCH = 'MANY_PERFECT_MATCH';
export const NO_PERFECT_MATCH   = 'NO_PERFECT_MATCH';
export const READY_TO_BUY       = 'READY_TO_BUY';
export const NO_ENOUGH_STOCK    = 'NO_ENOUGH_STOCK';
export const NO_STOCK           = 'NO_STOCK';
export const NO_PRICING         = 'NO_PRICING';
export const REPLACED           = 'REPLACED';
